import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import EditItemName from "../../../Common/Components/EditItemName";
import ButtonRightIconGreen from "modules/Common/Components/ButtonRightIconGreen";
import PlusIcon from "../../../../assets/img/CuratedContent/Plus.svg";
import styled from "styled-components";
import CampaignCard from "../../Shared/CampaignCard";
import AddCampaign from "../../Shared/AddCampaign";
import AccountSearch from "../../../Content/MyAccounts/Components/AccountSearch";
import { Row, Col } from "antd";
import { FC } from "react";
import CampaignsTab from "./CampaignsTab";

interface ICreateCampaign {
  tab?: string;
  page?: string;
}

const CreateCampaign: FC<ICreateCampaign> = (props) => {
  const recentlyChangedAssets = ["asset 1", "asset 1", "asset 1"];
  const allAssets: any = useSelector((state: RootState) => console.log(state));
  const { page, tab } = props;
  const [recentlyChangedAssetsLength, setrecentlyChangedAssetsLength] = useState(recentlyChangedAssets.length);

  const deleteHandler = (index: any): void => {
    recentlyChangedAssets.splice(index, 1);
    setrecentlyChangedAssetsLength(recentlyChangedAssets.length);
  };
  return (
    <Wrapper2>
      <div className="wrapper-box">
        <Row>
          <Col span={20}>
            <EditItemName itemName={"Campaign name goes here"}></EditItemName>
          </Col>
          <Col span={4}>
            <div className="right-aligned center-aligned-y">
              <ButtonRightIconGreen icon={PlusIcon} label="Create new Email"></ButtonRightIconGreen>
            </div>
          </Col>
        </Row>
        <div className="margin-bottom-md margin-top-md">
          <CampaignsTab page={page} tab={tab} />
        </div>
        <div className="d-flex flex-column asset-section">
          <ParagraphLabel className="asset-section-text">Recently changed</ParagraphLabel>
          <Row gutter={56}>
            {recentlyChangedAssets.map((campaign, index) => (
              <Col key={index} className="gutter-row" span={6}>
                <CampaignCard index={index} deleteHandler={deleteHandler} />
              </Col>
            ))}
            {
              <Col className="gutter-row" span={6}>
                <AddCampaign className="add-asset-plus-style" />
              </Col>
            }
          </Row>
          <Row>
            <Col span={20}>
              <ParagraphLabel className="asset-section-text">All Assets</ParagraphLabel>
            </Col>
            <Col span={4}>
              <div className="right-aligned">
                <AccountSearch placeholder="Filter Assets…" />
              </div>
            </Col>
          </Row>
          <Row gutter={56}>
            {allAssets?.map((asset: any, index: any) => (
              <Col key={index} className="gutter-row" span={6}>
                <CampaignCard index={index} deleteHandler={deleteHandler} />
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </Wrapper2>

    // {/* </Wrapper>
  );
};

export default CreateCampaign;

const Wrapper2 = styled.div`
  .add-asset-plus-style {
    height: 286.5px;
  }
`;

const Wrapper = styled.div`
  background-color: #fff;
  box-sizing: border-box;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .content-inner {
    display: flex;
    align-self: flex-end;
    flex-direction: column;
    background-color: #f2f2f2;
    box-sizing: border-box;
    width: calc(100% - 88px);
    float: right;
    min-height: 100vh;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: calc(100% - 63px);
    }
    .wrapper-box {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      padding: 70px 90px 0 90px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding: 50px 65px 0 65px;
      }
    }
    .asset-section {
      margin-top: 20px;
    }
    .asset-section-text {
      color: #67696a;
      font-weight: 500;
      font-family: "robotomedium";
      font-size: 22px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 16px;
      }
    }
  }
  .right-aligned {
    display: flex;
    justify-content: flex-end;
  }
  .center-aligned-y {
    height: 100%;
    align-items: center;
  }
  .margin-bottom-md {
    margin-bottom: 1em;
  }
  .margin-top-md {
    margin-top: 1em;
  }
`;

const ParagraphLabel = styled.div`
  color: #67696a;
  font-weight: 500;
  font-family: "robotomedium";
  font-size: 22px;
  margin-bottom: 16px;
`;

// const Wrapper = styled.div`
//   background-color: #fff;
//   box-sizing: border-box;
//   background-size: cover;
//   min-height: 100vh;
//   display: flex;
//   flex-direction: column;
//   justify-content: flex-end;
//   .content-inner {
//     display: flex;
//     align-self: flex-end;
//     flex-direction: column;
//     background-color: #f2f2f2;
//     box-sizing: border-box;
//     width: calc(100% - 88px);
//     float: right;
//     min-height: 100vh;
//     .wrapper-box {
//       display: flex;
//       flex-direction: column;
//       flex-grow: 1;
//       padding: 70px 90px 0 90px;
//       @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
//         padding: 35px 50px 0 50px;
//       }
//     }
//     .asset-section {
//       margin-top: 20px;
//     }
//     .asset-section-text {
//       color: #67696a;
//       font-weight: 500;
//       font-family: "robotomedium";
//       font-size: 22px;
//     }
//   }
//   .right-aligned {
//     display: flex;
//     justify-content: flex-end;
//   }
//   .center-aligned-y {
//     height: 100%;
//     align-items: center;
//   }
//   .margin-bottom-md {
//     margin-bottom: 1em;
//   }
//   .margin-top-md {
//     margin-top: 1em;
//   }
// `;
